import React from 'react'
import DocumentDialog, { DocumentSection } from '../DocumentDialog'

interface BillOfLadingDialogProps {
  data: any
  shipmentId: string
  documentId: string
  onSave?: (updatedData: any, changes?: any[]) => void
}

const BillOfLadingDialog: React.FC<BillOfLadingDialogProps> = ({ data, shipmentId, documentId, onSave }) => {
  // Define sections for Bill of Lading
  const sections: DocumentSection[] = [
    {
      id: 'documentInfo',
      title: 'Document Information',
      layout: 'double',
      fields: [
        { type: 'field', label: 'Document #', path: 'documentNumber' },
        { type: 'field', label: 'Booking #', path: 'bookingNumber' },
        { type: 'field', label: 'Issue Date', path: 'issueDate' },
        { type: 'field', label: 'Shipment Date', path: 'shipmentDate' },
        { type: 'field', label: 'Original Document', path: 'isOriginal' },
        { type: 'field', label: 'Number of Originals', path: 'numberOfOriginals' },
      ],
    },
    {
      id: 'parties',
      title: 'Parties',
      layout: 'grid',
      fields: [
        {
          type: 'object',
          label: 'Shipper',
          path: 'shipper',
          fields: [
            { label: 'Name', path: 'name' },
            { label: 'Address', path: 'address' },
            { label: 'Contact', path: 'contact' },
          ],
        },
        {
          type: 'object',
          label: 'Consignee',
          path: 'consignee',
          fields: [
            { label: 'Name', path: 'name' },
            { label: 'Address', path: 'address' },
            { label: 'Contact', path: 'contact' },
          ],
        },
        {
          type: 'object',
          label: 'Notify Party',
          path: 'notifyParty',
          fields: [
            { label: 'Name', path: 'name' },
            { label: 'Address', path: 'address' },
            { label: 'Contact', path: 'contact' },
          ],
          optional: true,
        },
      ],
    },
    {
      id: 'vesselAndLocations',
      title: 'Vessel and Locations',
      layout: 'grid',
      fields: [
        {
          type: 'object',
          label: 'Vessel Information',
          path: 'vessel',
          fields: [
            { label: 'Vessel Name', path: 'name' },
            { label: 'Voyage', path: 'voyage' },
          ],
        },
        {
          type: 'object',
          label: 'Shipping Locations',
          path: '',
          fields: [
            { label: 'Place of Receipt', path: 'placeOfReceipt' },
            { label: 'Port of Loading', path: 'portOfLoading' },
            { label: 'Port of Discharge', path: 'portOfDischarge' },
            { label: 'Place of Delivery', path: 'placeOfDelivery' },
          ],
        },
      ],
    },
    {
      id: 'containers',
      title: 'Containers',
      layout: 'single',
      fields: [
        {
          type: 'array',
          label: 'Containers',
          path: 'containers',
          columns: [
            { label: 'Container #', path: 'number' },
            { label: 'Size', path: 'size' },
            { label: 'Type', path: 'type' },
            { label: 'Seal #', path: 'sealNumber' },
          ],
          optional: true,
        },
      ],
    },
    {
      id: 'cargo',
      title: 'Cargo Details',
      layout: 'single',
      fields: [
        {
          type: 'array',
          label: 'Cargo Details',
          path: 'cargo',
          columns: [
            { label: 'Description', path: 'description' },
            { label: 'Packages', path: 'packages' },
            {
              label: 'Weight',
              path: 'weight',
              complexType: 'weight',
            },
            {
              label: 'Volume',
              path: 'volume',
              complexType: 'volume',
            },
            {
              label: 'Value',
              path: 'value',
              complexType: 'currency',
            },
            {
              label: 'Dimensions',
              path: 'dimensions',
              complexType: 'dimensions',
            },
            { label: 'Marks & Numbers', path: 'marksAndNumbers' },
          ],
        },
      ],
    },
    {
      id: 'freightAndSignatures',
      title: 'Freight and Signatures',
      layout: 'grid',
      fields: [
        {
          type: 'object',
          label: 'Freight Information',
          path: '',
          fields: [
            { label: 'Freight Payable At', path: 'freightPayableAt' },
            { label: 'Freight Terms', path: 'freightTerms' },
            { label: 'Freight Charges', path: 'freightCharges', complexType: 'currency' },
          ],
        },
        {
          type: 'object',
          label: 'Signatures',
          path: '',
          fields: [
            { label: 'Carrier Signature', path: 'carrierSignature' },
            { label: 'Shipper Signature', path: 'shipperSignature' },
            { label: 'Date of Signature', path: 'dateOfSignature' },
          ],
        },
      ],
    },
    {
      id: 'specialInstructions',
      title: 'Special Instructions',
      layout: 'single',
      fields: [
        {
          type: 'field',
          path: 'specialInstructions',
          fullWidth: true,
        },
      ],
    },
  ]

  return (
    <DocumentDialog
      documentData={data}
      schema={{}}
      sections={sections}
      documentType="Bill of Lading"
      onSave={onSave}
      shipmentId={shipmentId}
      documentId={documentId}
    />
  )
}

export default BillOfLadingDialog
